
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("hc71J", function(module, exports) {

var $dh538 = parcelRequire("dh538");

function $484fceb19a2d8a9d$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $484fceb19a2d8a9d$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $484fceb19a2d8a9d$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $484fceb19a2d8a9d$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $484fceb19a2d8a9d$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $484fceb19a2d8a9d$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $484fceb19a2d8a9d$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            if (mimetype === 'text/plain' && (0, $dh538.fg)('platform_media-default-code-viewer-for-plain-text')) return 'text';
            return null;
    }
}
module.exports["getExtension"] = $484fceb19a2d8a9d$export$78d71f9ed5534abe;
module.exports["isCodeViewerItem"] = $484fceb19a2d8a9d$export$bb139b46f345ca28;
module.exports["getLanguageType"] = $484fceb19a2d8a9d$export$ba4368c844580f9e;

});

parcelRegister("2nsxJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jRNsq = parcelRequire("jRNsq");


var $i2CQL = parcelRequire("i2CQL");

function $d27af5912c8c4782$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles } = options;
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const fileState = (0, $i2CQL.useMediaStore)((state)=>state.files[id]);
    (0, $42omo.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState
    };
}
module.exports["useFileState"] = $d27af5912c8c4782$export$90ff537b0999afb;

});

parcelRegister("i2CQL", function(module, exports) {

var $equi6 = parcelRequire("equi6");


var $jRNsq = parcelRequire("jRNsq");

const $4af3bbf76333cbc2$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $equi6.useStore)(store, selector, equals);
function $4af3bbf76333cbc2$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $4af3bbf76333cbc2$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}
module.exports["useMediaStore"] = $4af3bbf76333cbc2$export$8a9cc8c330400af8;

});

parcelRegister("equi6", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $a80afd8c2b9b4a58$export$6ccbb43953eebf8);

var $l7KxQ = parcelRequire("l7KxQ");


var $42omo = parcelRequire("42omo");


var $hpRUx = parcelRequire("hpRUx");

var $a80afd8c2b9b4a58$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $a80afd8c2b9b4a58$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo)));
const { useSyncExternalStoreWithSelector: $a80afd8c2b9b4a58$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($hpRUx)));
let $a80afd8c2b9b4a58$var$didWarnAboutEqualityFn = false;
const $a80afd8c2b9b4a58$var$identity = (arg)=>arg;
function $a80afd8c2b9b4a58$export$6ccbb43953eebf8(api, selector = $a80afd8c2b9b4a58$var$identity, equalityFn) {
    if (($a80afd8c2b9b4a58$import_meta.env ? $a80afd8c2b9b4a58$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$a80afd8c2b9b4a58$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $a80afd8c2b9b4a58$var$didWarnAboutEqualityFn = true;
    }
    const slice = $a80afd8c2b9b4a58$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $a80afd8c2b9b4a58$var$useDebugValue(slice);
    return slice;
}
const $a80afd8c2b9b4a58$var$createImpl = (createState)=>{
    if (($a80afd8c2b9b4a58$import_meta.env ? $a80afd8c2b9b4a58$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $l7KxQ.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$a80afd8c2b9b4a58$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $a80afd8c2b9b4a58$export$185802fd694ee1f5 = (createState)=>createState ? $a80afd8c2b9b4a58$var$createImpl(createState) : $a80afd8c2b9b4a58$var$createImpl;
var $a80afd8c2b9b4a58$export$2e2bcd8739ae039 = (createState)=>{
    if (($a80afd8c2b9b4a58$import_meta.env ? $a80afd8c2b9b4a58$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $a80afd8c2b9b4a58$export$185802fd694ee1f5(createState);
};

});

parcelRegister("21oLb", function(module, exports) {
const $fc8b4ffdd5763df8$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $fc8b4ffdd5763df8$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $fc8b4ffdd5763df8$export$43142f95b8de7a91 = (orientation)=>{
    return $fc8b4ffdd5763df8$var$ORIENT_TRANSFORMS[orientation];
};
module.exports["isRotated"] = $fc8b4ffdd5763df8$export$8af433705f41088f;
module.exports["getCssFromImageOrientation"] = $fc8b4ffdd5763df8$export$43142f95b8de7a91;

});

parcelRegister("6YcJ1", function(module, exports) {

var $ek6ZB = parcelRequire("ek6ZB");


var $5kpUJ = parcelRequire("5kpUJ");


var $a6JW6 = parcelRequire("a6JW6");


var $21oLb = parcelRequire("21oLb");

const { Orientation: $42560c37dcf792ae$var$Orientation, XResolution: $42560c37dcf792ae$var$XResolution } = (0, $ek6ZB.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $42560c37dcf792ae$var$DPI_WEB_BASELINE = 72;
async function $42560c37dcf792ae$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $42560c37dcf792ae$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $42560c37dcf792ae$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $42560c37dcf792ae$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $42560c37dcf792ae$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $42560c37dcf792ae$var$DPI_WEB_BASELINE;
        else return $42560c37dcf792ae$export$268f92356524130b(tags, $42560c37dcf792ae$var$XResolution, $42560c37dcf792ae$var$DPI_WEB_BASELINE) / $42560c37dcf792ae$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $42560c37dcf792ae$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$42560c37dcf792ae$var$Orientation]) {
        const tagValue = tags[$42560c37dcf792ae$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $ek6ZB.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $42560c37dcf792ae$export$67689507e8404821(file) {
    const tags = await (0, $5kpUJ.readImageMetaTags)(file);
    return $42560c37dcf792ae$var$getOrientationFromTags(tags);
}
function $42560c37dcf792ae$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $42560c37dcf792ae$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $42560c37dcf792ae$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $5kpUJ.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $42560c37dcf792ae$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $42560c37dcf792ae$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $a6JW6.loadImage)(src);
        const { width: width, height: height } = (0, $a6JW6.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}
module.exports["getImageInfo"] = $42560c37dcf792ae$export$2176b0e68c10508f;
module.exports["getOrientation"] = $42560c37dcf792ae$export$67689507e8404821;

});

parcelRegister("ek6ZB", function(module, exports) {
var $8a97053409898982$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $8a97053409898982$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $8a97053409898982$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};
module.exports["ImageType"] = $8a97053409898982$export$48c85e6e32ef0825;
module.exports["SupportedImageMetaTag"] = $8a97053409898982$export$e369bb48cf33e564;
module.exports["ExifOrientation"] = $8a97053409898982$export$f6ea0c89fd7d156;

});

parcelRegister("5kpUJ", function(module, exports) {

var $ek6ZB = parcelRequire("ek6ZB");


var $gg2Io = parcelRequire("gg2Io");


var $284pz = parcelRequire("284pz");


var $joOsL = parcelRequire("joOsL");

async function $291ad249ab0ec7e3$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $ek6ZB.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $284pz.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $joOsL.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $ek6ZB.ImageType).JPEG) return await (0, $gg2Io.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}
module.exports["readImageMetaTags"] = $291ad249ab0ec7e3$export$41982b5c7acb23c4;

});

parcelRegister("gg2Io", function(module, exports) {

var $ek6ZB = parcelRequire("ek6ZB");

const { XResolution: $b1cf2398fd086f5b$var$XResolution, YResolution: $b1cf2398fd086f5b$var$YResolution } = (0, $ek6ZB.SupportedImageMetaTag);
let $b1cf2398fd086f5b$var$loadImage;

function $b1cf2398fd086f5b$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$b1cf2398fd086f5b$var$loadImage) {
            const module = await (parcelRequire("8vQIW"));
            $b1cf2398fd086f5b$var$loadImage = module.default || module;
        }
        $b1cf2398fd086f5b$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $b1cf2398fd086f5b$var$XResolution || key === $b1cf2398fd086f5b$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}
module.exports["readJPEGExifMetaData"] = $b1cf2398fd086f5b$export$556b2ccec62d7f2a;

});

parcelRegister("8vQIW", function(module, exports) {

let $632a1dd47094042d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $632a1dd47094042d$var$load("b8BDn").then(()=>parcelRequire('6fuwe'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("284pz", function(module, exports) {

var $a6JW6 = parcelRequire("a6JW6");

let $0075b80fbc950777$var$pngChunksExtract;

async function $0075b80fbc950777$export$5fb37736440fca6f(file) {
    if (!$0075b80fbc950777$var$pngChunksExtract) {
        const module = await (parcelRequire("9MxN8"));
        $0075b80fbc950777$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $a6JW6.fileToArrayBuffer)(file);
    const chunks = $0075b80fbc950777$var$pngChunksExtract(buffer);
    return await $0075b80fbc950777$export$9185743fdd58ce45(chunks);
}
async function $0075b80fbc950777$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}
module.exports["readPNGXMPMetaData"] = $0075b80fbc950777$export$5fb37736440fca6f;

});

parcelRegister("a6JW6", function(module, exports) {

var $lzyQK = parcelRequire("lzyQK");


var $b4DX7 = parcelRequire("b4DX7");


var $dfQbH = parcelRequire("dfQbH");


var $lkBga = parcelRequire("lkBga");


var $9AnKp = parcelRequire("9AnKp");


var $d77HU = parcelRequire("d77HU");


var $4dLYc = parcelRequire("4dLYc");


var $5W6v1 = parcelRequire("5W6v1");


var $av4P2 = parcelRequire("av4P2");


var $giYeH = parcelRequire("giYeH");


var $eWLPt = parcelRequire("eWLPt");


var $gH8Rx = parcelRequire("gH8Rx");


var $iFCP2 = parcelRequire("iFCP2");


var $cQbj1 = parcelRequire("cQbj1");


var $7t8Pn = parcelRequire("7t8Pn");


var $hc71J = parcelRequire("hc71J");

function $a344fc5ee1d7372a$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $a344fc5ee1d7372a$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $a344fc5ee1d7372a$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $a344fc5ee1d7372a$export$849633012686f7ee(file)
    };
}
async function $a344fc5ee1d7372a$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $a344fc5ee1d7372a$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $a344fc5ee1d7372a$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $a344fc5ee1d7372a$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $a344fc5ee1d7372a$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $a344fc5ee1d7372a$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $a344fc5ee1d7372a$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lzyQK)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($av4P2)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eWLPt)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($av4P2)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($giYeH)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5W6v1)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lkBga)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cQbj1)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dfQbH)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($b4DX7)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iFCP2)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gH8Rx)))
    }
];
function $a344fc5ee1d7372a$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $a344fc5ee1d7372a$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $hc71J.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7t8Pn)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9AnKp)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d77HU)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4dLYc)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}
module.exports["dataURItoFile"] = $a344fc5ee1d7372a$export$80d19edb7b1ae293;
module.exports["fileToDataURI"] = $a344fc5ee1d7372a$export$849633012686f7ee;
module.exports["getFileInfo"] = $a344fc5ee1d7372a$export$ca39f27fe4f7d9b4;
module.exports["fileToArrayBuffer"] = $a344fc5ee1d7372a$export$956310555b96755a;
module.exports["loadImage"] = $a344fc5ee1d7372a$export$fe58198efe02b173;
module.exports["readImageNaturalOrientationFromDOM"] = $a344fc5ee1d7372a$export$325d46491952db2d;
module.exports["findParentByClassname"] = $a344fc5ee1d7372a$export$89ff65f1d45dfb03;
module.exports["getMimeIcon"] = $a344fc5ee1d7372a$export$61a1de0822e2820;

});

parcelRegister("d77HU", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $98c1e84a3b388e2b$var$_react = $98c1e84a3b388e2b$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $98c1e84a3b388e2b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $98c1e84a3b388e2b$var$Figma24Icon = (props)=>/*#__PURE__*/ $98c1e84a3b388e2b$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$98c1e84a3b388e2b$var$Figma24Icon.displayName = 'Figma24Icon';
var $98c1e84a3b388e2b$var$_default = module.exports.default = $98c1e84a3b388e2b$var$Figma24Icon;

});

parcelRegister("9MxN8", function(module, exports) {

let $71f2cf053b480bb9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $71f2cf053b480bb9$var$load("dLFEp").then(()=>parcelRequire('ahNRS'));

});

parcelRegister("joOsL", function(module, exports) {
function $2efab4fabe8932ef$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}
module.exports["parseXMPMetaData"] = $2efab4fabe8932ef$export$55c3bc9841b19de2;

});

parcelRegister("k0QVR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hZ6O7 = parcelRequire("hZ6O7");

var $dIgeg = parcelRequire("dIgeg");


var $hXlr4 = parcelRequire("hXlr4");

var $2nsxJ = parcelRequire("2nsxJ");

var $jRNsq = parcelRequire("jRNsq");


var $JXmwv = parcelRequire("JXmwv");


var $dh538 = parcelRequire("dh538");


var $9x4nt = parcelRequire("9x4nt");


var $fgSvy = parcelRequire("fgSvy");


var $cCL2U = parcelRequire("cCL2U");


var $kJP4J = parcelRequire("kJP4J");

var $2dkDS = parcelRequire("2dkDS");

var $gL31c = parcelRequire("gL31c");


var $CPDDv = parcelRequire("CPDDv");

var $dXMn6 = parcelRequire("dXMn6");


var $hNBEk = parcelRequire("hNBEk");

// invisible gif for SSR preview to show the underlying spinner until the src is replaced by
// the actual image src in the inline script
const $24cb43d67162c399$var$DEFAULT_SSR_PREVIEW = {
    dataURI: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
    dimensions: {
        width: 100,
        height: 100
    },
    source: 'ssr-server'
};
const $24cb43d67162c399$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, useSrcSet: useSrcSet = false, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const [status, setStatus] = (0, $42omo.useState)('loading');
    const [error, setError] = (0, $42omo.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $42omo.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $42omo.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $42omo.useState)('not-resolved');
    const ssrReliabilityRef = (0, $42omo.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const ufoContext = (0, $9x4nt.useInteractionContext)();
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    (0, $42omo.useLayoutEffect)(()=>{
        if (isLoading && (0, $dh538.fg)('platform_close_image_blindspot_2')) return ufoContext?.hold('img-loading');
    }, [
        ufoContext,
        isLoading
    ]);
    const requestDimensions = (0, $42omo.useMemo)(()=>dimensions ? (0, $hNBEk.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $hNBEk.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $gL31c.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $dXMn6.getSSRData)(identifier);
            if (ssrData?.error) ssrReliabilityRef.current.server = {
                status: 'fail',
                ...ssrData.error
            };
            if (!ssrData?.dataURI) try {
                return (0, $kJP4J.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
            } catch (e) {
                ssrReliabilityRef.current[ssr] = {
                    status: 'fail',
                    ...(0, $fgSvy.extractErrorInfo)(e, traceContext)
                };
            }
            else {
                const { dimensions: dimensions, dataURI: dataURI, srcSet: srcSet } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data',
                    srcSet: srcSet
                };
            }
        }
    };
    const [preview, setPreview] = (0, $42omo.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $2nsxJ.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $hZ6O7.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $42omo.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $42omo.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || fileState?.status === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && fileState?.status === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $cCL2U.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && fileState?.status === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $cCL2U.MediaFilePreviewError)('metadata-fetch', (0, $dIgeg.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $hNBEk.useCurrentValueRef)(()=>{
        return (0, $kJP4J.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $42omo.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            setIsLoading(true);
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $hNBEk.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setIsLoading(false);
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $hNBEk.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $42omo.useEffect)(()=>{
        const cachedPreview = (0, $gL31c.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $hNBEk.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $2dkDS.isSupportedLocalPreview)(mediaType) && (0, $JXmwv.isMimeTypeSupportedByBrowser)(mimeType || '')) {
            // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
            // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
            // Then, local Preview NOT available
            setIsLoading(true);
            (0, $kJP4J.getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current).then(setPreview).catch((e)=>{
                setIsBannedLocalPreview(true);
                // CXP-2723 TODO: We might have to wrap this error in MediaCardError
                setNonCriticalError(e);
            }).finally(()=>{
                setIsLoading(false);
            });
        } else if (!error && !nonCriticalError && (!preview || (0, $hNBEk.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $kJP4J.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) {
            // If the preview is SSR and it's a blob URL, we can skip the refetch
            if (preview && (0, $kJP4J.isSSRPreview)(preview) && preview.dataURI.startsWith('blob:') && (0, $dh538.fg)('media-perf-uplift-mutation-fix')) return;
            setIsLoading(true);
            getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
                const wrappedError = (0, $cCL2U.ensureMediaFilePreviewError)('preview-fetch', e);
                if (!preview) {
                    setStatus('error');
                    setError(wrappedError);
                } else // If there is already a preview, we consider it a non-critical error
                setNonCriticalError(wrappedError);
            }).finally(()=>{
                setIsLoading(false);
            });
        }
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $42omo.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $kJP4J.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current.client = (0, $fgSvy.createFailedSSRObject)(failedPreview, traceContext);
        const isSSR = (0, $kJP4J.isSSRDataPreview)(failedPreview);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if (isSSR) {
            ssrReliabilityRef.current.server = (0, $fgSvy.createFailedSSRObject)(failedPreview, traceContext);
            ssrReliabilityRef.current.client = (0, $fgSvy.createFailedSSRObject)(failedPreview, traceContext);
        }
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview?.dataURI) return;
        const isLocal = (0, $kJP4J.isLocalPreview)(failedPreview);
        const isRemote = (0, $kJP4J.isRemotePreview)(failedPreview);
        if (isLocal || isRemote || isSSR) {
            const error = new (0, $cCL2U.ImageLoadError)(failedPreview?.source);
            (0, $gL31c.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $42omo.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $kJP4J.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current.client = {
                status: 'success'
            };
            /*
        If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
      */ if ((0, $kJP4J.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') {
                ssrReliabilityRef.current.server = {
                    status: 'success'
                };
                ssrReliabilityRef.current.client = {
                    status: 'success'
                };
            }
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview?.dataURI !== preview?.dataURI) return;
    }, [
        preview?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $CPDDv.generateScriptProps)(identifier, preview?.dataURI, preview?.srcSet, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined, {
            'media-perf-uplift-mutation-fix': (0, $dh538.fg)('media-perf-uplift-mutation-fix')
        }) : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $hXlr4.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: ssr === 'server' && useSrcSet && (0, $dh538.fg)('media-perf-uplift-mutation-fix') ? $24cb43d67162c399$var$DEFAULT_SSR_PREVIEW : preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};
module.exports["useFilePreview"] = $24cb43d67162c399$export$4eaebdef02112fe4;

});

parcelRegister("hXlr4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $jRNsq = parcelRequire("jRNsq");


var $c5usV = parcelRequire("c5usV");


var $fLL9S = parcelRequire("fLL9S");

function $cc642dccb112c2b8$var$useCurrentValueRef(value) {
    const ref = (0, $42omo.useRef)(value);
    ref.current = value;
    return ref;
}
const $cc642dccb112c2b8$export$46fd859414de9d62 = (id, options = {})=>{
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const innerRef = (0, $42omo.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const registerCopyIntentRef = $cc642dccb112c2b8$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $c5usV.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $c5usV.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $42omo.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $dh538.fg)('platform_media_cross_client_copy')) elem?.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $42omo.useCallback)(async ()=>{
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
        if (currentSelectionContainsNode) registerCopyIntentRef.current();
    }, [
        registerCopyIntentRef
    ]);
    (0, $42omo.useEffect)(()=>{
        if ((0, $dh538.fg)('platform_media_cross_client_copy')) (0, $fLL9S.getDocument)()?.addEventListener('copy', onGlobalCopy);
        return ()=>(0, $fLL9S.getDocument)()?.removeEventListener('copy', onGlobalCopy);
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};
module.exports["useCopyIntent"] = $cc642dccb112c2b8$export$46fd859414de9d62;

});

parcelRegister("c5usV", function(module, exports) {

var $2ASLw = parcelRequire("2ASLw");

const $e6e8f319cddd6152$var$getRequestErrorDetails = (err)=>{
    if ((0, $2ASLw.isRequestError)(err)) return {
        request: {
            statusCode: err.metadata?.statusCode,
            traceContext: err.metadata?.traceContext,
            mediaEnv: err.metadata?.mediaEnv,
            mediaRegion: err.metadata?.mediaRegion
        }
    };
    return undefined;
};
const $e6e8f319cddd6152$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $2ASLw.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$e6e8f319cddd6152$var$getRequestErrorDetails(error)
        }
    };
};
const $e6e8f319cddd6152$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};
module.exports["getCopyIntentErrorPayload"] = $e6e8f319cddd6152$export$3ab52330b662b987;
module.exports["getCopyIntentSuccessPayload"] = $e6e8f319cddd6152$export$aacb463551da2e8f;

});

parcelRegister("fLL9S", function(module, exports) {
const $88290e8f8b3102b1$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};
module.exports["getDocument"] = $88290e8f8b3102b1$export$f65ca476c09acec0;

});

parcelRegister("fgSvy", function(module, exports) {

var $dIgeg = parcelRequire("dIgeg");


var $cCL2U = parcelRequire("cCL2U");

const $2de7fc98fb618862$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $dIgeg.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $2de7fc98fb618862$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $2de7fc98fb618862$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $dIgeg.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $2de7fc98fb618862$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $dIgeg.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};
const $2de7fc98fb618862$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $2de7fc98fb618862$export$4af9d71992e89714(error),
        error: $2de7fc98fb618862$export$88c61dcad53762da(error),
        errorDetail: $2de7fc98fb618862$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $2de7fc98fb618862$export$29aa614726672b2e(error)
    };
};
const $2de7fc98fb618862$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$2de7fc98fb618862$export$74aaf4784c2edb2c(new (0, $cCL2U.ImageLoadError)(preview.source), metadataTraceContext)
    });
module.exports["extractErrorInfo"] = $2de7fc98fb618862$export$74aaf4784c2edb2c;
module.exports["createFailedSSRObject"] = $2de7fc98fb618862$export$768c370ed0dbaeb3;

});

parcelRegister("cCL2U", function(module, exports) {
class $3c049ab9f06e4fad$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $3c049ab9f06e4fad$export$2c035820a31723e extends $3c049ab9f06e4fad$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $3c049ab9f06e4fad$export$10ab445310d30114 extends $3c049ab9f06e4fad$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $3c049ab9f06e4fad$export$18e89b7e50818288 extends $3c049ab9f06e4fad$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $3c049ab9f06e4fad$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $3c049ab9f06e4fad$export$d0a45ab59b4606b extends $3c049ab9f06e4fad$export$96e559194c287cf4 {
    constructor(source){
        super($3c049ab9f06e4fad$var$getImageLoadPrimaryReason(source));
    }
}
function $3c049ab9f06e4fad$export$553696a6e769784c(err) {
    return err instanceof $3c049ab9f06e4fad$export$96e559194c287cf4;
}
const $3c049ab9f06e4fad$export$b380593ba3516c6f = (err)=>err instanceof $3c049ab9f06e4fad$export$2c035820a31723e;
const $3c049ab9f06e4fad$export$e1d87830b3784f94 = (err)=>err instanceof $3c049ab9f06e4fad$export$10ab445310d30114;
const $3c049ab9f06e4fad$export$443aeb298d35d79d = (err)=>$3c049ab9f06e4fad$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $3c049ab9f06e4fad$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($3c049ab9f06e4fad$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $3c049ab9f06e4fad$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $3c049ab9f06e4fad$export$96e559194c287cf4(primaryReason, error);
};
module.exports["MediaFilePreviewError"] = $3c049ab9f06e4fad$export$96e559194c287cf4;
module.exports["LocalPreviewError"] = $3c049ab9f06e4fad$export$2c035820a31723e;
module.exports["RemotePreviewError"] = $3c049ab9f06e4fad$export$10ab445310d30114;
module.exports["SsrPreviewError"] = $3c049ab9f06e4fad$export$18e89b7e50818288;
module.exports["ImageLoadError"] = $3c049ab9f06e4fad$export$d0a45ab59b4606b;
module.exports["ensureMediaFilePreviewError"] = $3c049ab9f06e4fad$export$7156ce7b78b49bd7;

});

parcelRegister("kJP4J", function(module, exports) {

var $Girkv = parcelRequire("Girkv");


var $cCL2U = parcelRequire("cCL2U");


var $gL31c = parcelRequire("gL31c");


var $2dkDS = parcelRequire("2dkDS");

const $8efa99034f89c3f1$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $Girkv.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $gL31c.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $8efa99034f89c3f1$var$getDataUri = (mediaClient, id, params, mediaBlobUrlAttrs)=>{
    const rawDataURI = mediaClient.getImageUrlSync(id, params);
    return mediaBlobUrlAttrs ? (0, $Girkv.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
};
const $8efa99034f89c3f1$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    try {
        const dataURI = $8efa99034f89c3f1$var$getDataUri(mediaClient, id, params, mediaBlobUrlAttrs);
        let srcSet = `${dataURI} 1x`;
        if (params.width) {
            const doubleDataURI = $8efa99034f89c3f1$var$getDataUri(mediaClient, id, {
                ...params,
                width: params.width * 2
            }, mediaBlobUrlAttrs);
            // We want to embed some meta context into dataURI for Copy/Paste to work.
            srcSet += `, ${doubleDataURI} 2x`;
        }
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1,
            srcSet: srcSet
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $cCL2U.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $8efa99034f89c3f1$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $8efa99034f89c3f1$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $8efa99034f89c3f1$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $8efa99034f89c3f1$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $8efa99034f89c3f1$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
const $8efa99034f89c3f1$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const remotePreview = await (0, $2dkDS.getRemotePreview)(mediaClient, id, params, traceContext);
    return $8efa99034f89c3f1$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
const $8efa99034f89c3f1$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
    const localPreview = await (0, $2dkDS.getLocalPreview)(filePreview);
    return $8efa99034f89c3f1$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
module.exports["getSSRPreview"] = $8efa99034f89c3f1$export$faf1c301c59a1bdc;
module.exports["isLocalPreview"] = $8efa99034f89c3f1$export$78ad02c5efc361c9;
module.exports["isRemotePreview"] = $8efa99034f89c3f1$export$87442a14a8a19e0;
module.exports["isSSRClientPreview"] = $8efa99034f89c3f1$export$36aae1afbc0a9661;
module.exports["isSSRDataPreview"] = $8efa99034f89c3f1$export$f366c2c8a792cce6;
module.exports["isSSRPreview"] = $8efa99034f89c3f1$export$dea79d05143ccf4;
module.exports["getAndCacheRemotePreview"] = $8efa99034f89c3f1$export$49721bcc26fb9388;
module.exports["getAndCacheLocalPreview"] = $8efa99034f89c3f1$export$98e935d981c884d;

});

parcelRegister("gL31c", function(module, exports) {

var $2hUgu = parcelRequire("2hUgu");

const $35b59c22b0648810$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $35b59c22b0648810$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $35b59c22b0648810$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $35b59c22b0648810$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $35b59c22b0648810$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
    }
}
const $35b59c22b0648810$export$b7e8ee3f7a41459 = new $35b59c22b0648810$export$7b50526c091bb915((0, $2hUgu.createObjectURLCache)());
module.exports["mediaFilePreviewCache"] = $35b59c22b0648810$export$b7e8ee3f7a41459;

});

parcelRegister("2hUgu", function(module, exports) {

var $majy4 = parcelRequire("majy4");


var $9trs7 = parcelRequire("9trs7");

const $0bd1a53c7b384653$export$36d0f9859761643d = 50;
class $0bd1a53c7b384653$var$ExtendedLRUCache extends (0, $9trs7.LRUMap) {
    shift() {
        const entry = super.shift();
        this.eventEmitter.emit('shift', entry);
        return entry;
    }
    on(event, callback) {
        this.eventEmitter.on(event, callback);
    }
    constructor(limit){
        super(limit);
        this.eventEmitter = void 0;
        this.eventEmitter = new (0, $majy4.EventEmitter2)();
    }
}
class $0bd1a53c7b384653$export$75d1c8c9ba1d0773 {
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        removed && URL.revokeObjectURL(removed.dataURI);
    }
    clear() {
        this.cache.clear();
    }
    constructor(size){
        this.cache = void 0;
        this.cache = new $0bd1a53c7b384653$var$ExtendedLRUCache(size);
        this.cache.on('shift', (entry)=>{
            if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
        });
    }
}
const $0bd1a53c7b384653$export$ba71be67d5c32535 = ()=>new $0bd1a53c7b384653$export$75d1c8c9ba1d0773($0bd1a53c7b384653$export$36d0f9859761643d);
module.exports["createObjectURLCache"] = $0bd1a53c7b384653$export$ba71be67d5c32535;

});

parcelRegister("2dkDS", function(module, exports) {

var $24z7I = parcelRequire("24z7I");


var $6YcJ1 = parcelRequire("6YcJ1");


var $cCL2U = parcelRequire("cCL2U");


var $eyZtk = parcelRequire("eyZtk");

const $706888ba5ac0fb3d$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $706888ba5ac0fb3d$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $6YcJ1.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $cCL2U.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $706888ba5ac0fb3d$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $eyZtk.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $cCL2U.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $706888ba5ac0fb3d$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $cCL2U.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $24z7I.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $706888ba5ac0fb3d$var$getImageLocalPreview(value);
            case 'video':
                return $706888ba5ac0fb3d$var$getVideoLocalPreview(value);
            default:
                throw new (0, $cCL2U.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $cCL2U.LocalPreviewError)('local-preview-unsupported');
};
const $706888ba5ac0fb3d$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $cCL2U.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};
module.exports["isSupportedLocalPreview"] = $706888ba5ac0fb3d$export$1fa85b75e8662d54;
module.exports["getLocalPreview"] = $706888ba5ac0fb3d$export$3d6ed68e437b8c99;
module.exports["getRemotePreview"] = $706888ba5ac0fb3d$export$bfe20bd01db02b3;

});

parcelRegister("eyZtk", function(module, exports) {
const $5b6ea74f3cda8ff5$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};
module.exports["takeSnapshot"] = $5b6ea74f3cda8ff5$export$4269d30173168e5c;

});

parcelRegister("CPDDv", function(module, exports) {

var $ucbUh = parcelRequire("ucbUh");

const $bd2cdc2cc4d0320a$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $bd2cdc2cc4d0320a$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
function $bd2cdc2cc4d0320a$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $bd2cdc2cc4d0320a$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $bd2cdc2cc4d0320a$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $bd2cdc2cc4d0320a$var$dashed = (param)=>param ? `-${param}` : '';
const $bd2cdc2cc4d0320a$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey })=>`${id}${$bd2cdc2cc4d0320a$var$dashed(collectionName)}${$bd2cdc2cc4d0320a$var$dashed(occurrenceKey)}`;
const $bd2cdc2cc4d0320a$export$4310981e0aa4ce67 = (key, paramDataURI, paramSrcSet, dimensions, error, featureFlags = {}, globalScope = window)=>{
    const mediaCardSsr = $bd2cdc2cc4d0320a$export$ede93d4564eaa8da(globalScope);
    if (featureFlags['media-perf-uplift-mutation-fix']) {
        const prevData = mediaCardSsr[key];
        const isPreviousImageLarger = prevData && prevData.dimensions?.width && dimensions?.width && prevData.dimensions.width > dimensions.width;
        const srcSet = isPreviousImageLarger ? prevData?.srcSet : paramSrcSet;
        const dataURI = isPreviousImageLarger ? prevData?.dataURI : paramDataURI;
        const img = script?.parentElement?.querySelector('img');
        if (img && dataURI) img.src = dataURI;
        if (img && srcSet) img.srcset = srcSet;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        img?.addEventListener('load', ()=>{
            if (img.currentSrc.startsWith('blob:')) return;
            fetch(img.currentSrc).then((res)=>res.blob()).then((blob)=>URL.createObjectURL(blob)).then((blobUrl)=>{
                img.src = blobUrl;
                img.srcset = '';
                mediaCardSsr[key] = {
                    ...mediaCardSsr[key],
                    dataURI: blobUrl,
                    srcSet: ''
                };
            }).catch((err)=>{
                mediaCardSsr[key] = {
                    ...mediaCardSsr[key],
                    error: err
                };
            });
        });
        mediaCardSsr[key] = isPreviousImageLarger ? prevData : {
            dataURI: dataURI,
            dimensions: dimensions,
            error: error,
            srcSet: srcSet
        };
    } else mediaCardSsr[key] = {
        dataURI: paramDataURI,
        dimensions: dimensions,
        error: error
    };
};
const $bd2cdc2cc4d0320a$var$generateScript = (identifier, dataURI, srcSet, dimensions, error, featureFlags = {})=>{
    const functionCall = (0, $ucbUh.printFunctionCall)($bd2cdc2cc4d0320a$export$4310981e0aa4ce67, $bd2cdc2cc4d0320a$export$a47fb462a08de82f(identifier), dataURI, srcSet, dimensions, error, featureFlags);
    return (0, $ucbUh.printScript)([
        $bd2cdc2cc4d0320a$export$ede93d4564eaa8da.toString(),
        $bd2cdc2cc4d0320a$export$96a3cfb3a41e9bb2.toString(),
        functionCall
    ]);
};
const $bd2cdc2cc4d0320a$export$de7c49925e44d75d = (identifier, dataURI, srcSet, dimensions, error, featureFlags = {})=>({
        dangerouslySetInnerHTML: {
            __html: $bd2cdc2cc4d0320a$var$generateScript(identifier, dataURI, srcSet, dimensions, error, featureFlags)
        }
    });
module.exports["getMediaCardSSR"] = $bd2cdc2cc4d0320a$export$ede93d4564eaa8da;
module.exports["getKey"] = $bd2cdc2cc4d0320a$export$a47fb462a08de82f;
module.exports["generateScriptProps"] = $bd2cdc2cc4d0320a$export$de7c49925e44d75d;

});

parcelRegister("ucbUh", function(module, exports) {
const $728d0f08f4e41c7f$var$printParam = (param)=>{
    if (typeof param === 'string') return `'${param}'`;
    else if (typeof param === 'object') return JSON.stringify(param);
    else if (param === undefined) return 'undefined';
    return param;
};
const $728d0f08f4e41c7f$var$printParams = (args)=>args.map((arg)=>$728d0f08f4e41c7f$var$printParam(arg)).join(',');
const $728d0f08f4e41c7f$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$728d0f08f4e41c7f$var$printParams(args)});`;
const $728d0f08f4e41c7f$export$8b902fb69a2f17c1 = (statements)=>`(function(){
			 let script = document.currentScript;
 			 ${statements.join(';')}
			 document.currentScript.remove();
		})();
		`;
module.exports["printFunctionCall"] = $728d0f08f4e41c7f$export$3742967cc82ac85a;
module.exports["printScript"] = $728d0f08f4e41c7f$export$8b902fb69a2f17c1;

});

parcelRegister("dXMn6", function(module, exports) {

var $CPDDv = parcelRequire("CPDDv");

const $f006128302984542$export$d3a890b0f7844b6f = (identifier)=>{
    const mediaCardSsr = (0, $CPDDv.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $CPDDv.getKey)(identifier)];
};
module.exports["getSSRData"] = $f006128302984542$export$d3a890b0f7844b6f;

});

parcelRegister("hNBEk", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $5debdc9c0997a52e$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
/** Verifies if the current screen is retina display */ function $5debdc9c0997a52e$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $5debdc9c0997a52e$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $5debdc9c0997a52e$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $5debdc9c0997a52e$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $42omo.useRef)(value);
    ref.current = value;
    return ref;
}
module.exports["isBigger"] = $5debdc9c0997a52e$export$912a00e9a5470d9a;
module.exports["createRequestDimensions"] = $5debdc9c0997a52e$export$3063221e86a58f9;
module.exports["useCurrentValueRef"] = $5debdc9c0997a52e$export$b3e10e1f0fbb71db;

});

var $835ea48f62909c8f$exports = {};

(parcelRequire("02nRr")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"h4k4y\",\"media.f957f526.js\",\"b8BDn\",\"js.a0af0607.js\",\"dLFEp\",\"png-chunks-extract.4b734ea9.js\"]"));


$parcel$global.rlb("h4k4y")
//# sourceMappingURL=media.f957f526.js.map
